import { NETWORK_URLS } from "../constants/NetworkConstants";
import { apiUrl, headerHelper } from '../helper/Utility'

export default class FrontConfigService {
  // REQUEST TO GET FRONTEND DETAILS

  static getData = async (token) => {
    var endpoint = NETWORK_URLS.front_configs;
    var encodedUrl = apiUrl() + endpoint;
    try {
      const response = await fetch(encodedUrl, { method: "GET", headers: headerHelper(token) });
      const json = await response.json();
      return json;
    } catch {
        console.log("error");
        return [];
    }
  };

  static getSpecialItems = async (token) => {
    const endpoint = NETWORK_URLS.special_items;
    const encodedUrl = apiUrl() + endpoint;
    try {
      const response = await fetch(encodedUrl, { method: "GET", headers: headerHelper(token) });
      const json = await response.json();
      return { json: json, status: response.status};
    } catch {
        console.log("error");
        return [];
    }
  };
}